var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2179_1942",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5714 0H1.42857C0.639593 0 0 0.639593 0 1.42857V12.8571C0 13.6461 0.639593 14.2857 1.42857 14.2857H18.5714C19.3604 14.2857 20 13.6461 20 12.8571V1.42857C20 0.639593 19.3604 0 18.5714 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2179_1942)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5725 0.178711H1.42969C0.739332 0.178711 0.179688 0.738355 0.179688 1.42871V12.8573C0.179688 13.5476 0.739332 14.1073 1.42969 14.1073H18.5725C19.2629 14.1073 19.8225 13.5476 19.8225 12.8573V1.42871C19.8225 0.738355 19.2629 0.178711 18.5725 0.178711Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 14.2857
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2179_1942",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -7,
    y: -7,
    width: 34,
    height: 29
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5745 0.178223H1.43164C0.741285 0.178223 0.181641 0.737867 0.181641 1.42822V12.8568C0.181641 13.5471 0.741285 14.1068 1.43164 14.1068H18.5745C19.2649 14.1068 19.8245 13.5471 19.8245 12.8568V1.42822C19.8245 0.737867 19.2649 0.178223 18.5745 0.178223Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 14.2857
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2179_1942)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00195312 9.5236H20.002V4.76172H0.00195312V9.5236Z",
    fill: "#0C47B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00195312 14.2859H20.002V9.52393H0.00195312V14.2859Z",
    fill: "#E53B35"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRu);
export default __webpack_public_path__ + "static/media/ru.99ec7b476e7870b34badceb732017cda.svg";
export { ForwardRef as ReactComponent };